import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { InputSwitch, InputSwitchChangeEvent } from 'primeng/inputswitch';

@Component({
  selector: 'm-switch',
  templateUrl: './m-switch.component.html',
  styleUrls: ['./m-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MSwitchComponent),
      multi: true
    }
  ]
})
export class MSwitchComponent
  extends InputSwitch
  implements ControlValueAccessor
{
  @Input() isToggle = false;
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() variant: 'tiny' | 'default' = 'default';
  @Input() onToggle?: (event: InputSwitchChangeEvent) => void;
  @Input() permissionAllowed = true;
  @Input() tooltip = '';

  @Input() switchFormControl = new FormControl();

  constructor(cd: ChangeDetectorRef) {
    super(cd);
  }

  override writeValue(value: any) {
    this.switchFormControl.setValue(value);
  }

  onSwitchToggle(event: InputSwitchChangeEvent) {
    if (this.onToggle) {
      this.onToggle(event);
    }
  }
}
